export default __webpack_public_path__ + "static/extended-data-console-view-06788857b21179dc4cbd408152d9017c.png";